<template>
  <div class="login-box">
    <h3 class="jk-mb-30">云志影藏后台管理系统</h3>
    <el-form ref="form" :model="form" style="width: 300px">
      <el-form-item>
        <el-input placeholder="请输入账号" v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          type="password"
          placeholder="请输入密码"
          v-model="form.passwordHash"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          class="jk-wp-100"
          type="primary"
          @click="startLogin"
          >登录</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { login } from "@/api/api";
export default {
  data() {
    return {
      form: {
        username: "",
        passwordHash: "",
      },
      loading: false,
    };
  },
  methods: {
    startLogin() {
      this.loading = true;
      login({
        ...this.form,
      })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.loginSuccess(res.data);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    loginSuccess(data) {
      this.$message.success("登录成功");
      this.$store.commit("login", data);
      const redirect = this.$route.query.redirect || "/";
      this.$router.push(redirect);
    },
  },
};
</script>

<style lang="scss" scoped>
.login-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
}
</style>